/**
 * Main App Component
 *
 * Defines routes and wraps app with AuthProvider
 */

import { Router, Route } from 'preact-router';
import { AuthProvider } from './context/AuthContext';
import { PrivateRoute } from './components/auth/PrivateRoute';

// Layouts
import PublicLayout from './components/layout/PublicLayout';
import MainLayout from './components/layout/MainLayout';

// Public pages
import { Login } from './pages/public/Login';
import { Register } from './pages/public/Register';

// Private pages
import { Dashboard } from './pages/private/Dashboard';
import { PendingApproval } from './pages/private/PendingApproval';
import { PaymentPending } from './pages/private/PaymentPending';
import { Rejected } from './pages/private/Rejected';
import { Inactive } from './pages/private/Inactive';
import { MyProfile } from './pages/private/MyProfile';
import { InstructorDetail } from './pages/private/InstructorDetail';

// Default 404 component
function NotFound() {
  return (
    <div class="min-h-screen bg-gray-100 flex items-center justify-center">
      <div class="text-center">
        <h1 class="text-6xl font-bold text-gray-900">404</h1>
        <p class="text-xl text-gray-600 mt-4">Página no encontrada</p>
        <a href="/" class="mt-6 inline-block text-blue-500 hover:text-blue-700">
          Volver al inicio
        </a>
      </div>
    </div>
  );
}

export function App() {
  return (
    <AuthProvider>
      <Router>
        {/* Public routes - Sin navbar */}
        <Route
          path="/login"
          component={() => (
            <PublicLayout>
              <Login />
            </PublicLayout>
          )}
        />
        <Route
          path="/registro"
          component={() => (
            <PublicLayout>
              <Register />
            </PublicLayout>
          )}
        />

        {/* Protected routes - Con navbar */}
        <Route
          path="/"
          component={() => (
            <PrivateRoute>
              <MainLayout>
                <Dashboard />
              </MainLayout>
            </PrivateRoute>
          )}
        />

        <Route
          path="/esperando-aprobacion"
          component={() => (
            <PrivateRoute>
              <MainLayout>
                <PendingApproval />
              </MainLayout>
            </PrivateRoute>
          )}
        />

        <Route
          path="/pago-pendiente"
          component={() => (
            <PrivateRoute>
              <MainLayout>
                <PaymentPending />
              </MainLayout>
            </PrivateRoute>
          )}
        />

        <Route
          path="/solicitud-rechazada"
          component={() => (
            <PrivateRoute>
              <MainLayout>
                <Rejected />
              </MainLayout>
            </PrivateRoute>
          )}
        />

        <Route
          path="/cuenta-inactiva"
          component={() => (
            <PrivateRoute>
              <MainLayout>
                <Inactive />
              </MainLayout>
            </PrivateRoute>
          )}
        />

        <Route
          path="/mi-perfil"
          component={() => (
            <PrivateRoute>
              <MainLayout>
                <MyProfile />
              </MainLayout>
            </PrivateRoute>
          )}
        />

        <Route
          path="/directorio/:id"
          component={({ id }: { id?: string }) => (
            <PrivateRoute>
              <MainLayout>
                <InstructorDetail id={id} />
              </MainLayout>
            </PrivateRoute>
          )}
        />

        {/* 404 - Not found */}
        <Route default component={NotFound} />
      </Router>
    </AuthProvider>
  );
}
